/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Work_Activity_File_Not_FoundInputs */

const vi_error_work_activity_file_not_found = /** @type {(inputs: Error_Work_Activity_File_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy tệp này trong hoạt động, có thể tệp vừa được gỡ. Vui lòng tải lại trang.`)
};

/**

* @param {Error_Work_Activity_File_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_work_activity_file_not_found = /** @type {((inputs?: Error_Work_Activity_File_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Work_Activity_File_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_work_activity_file_not_found(inputs)
});